import { ApryseSDK } from '../../pdf/ApryseSDK';
import { RotationDirection } from '../../pdf/Enums';
import { GlobalVariables } from '../../pdf/GlobalVariables';
import Command from './_Command';

export default class ZoomController extends Command {
    constructor(readonly rotation: RotationDirection, readonly Path: string | false) {
        const key = `rotationController-${rotation}`;
        GlobalVariables.registeredCommands[key] = () => {
            rotation === RotationDirection.clockwise
                ? ApryseSDK.documentViewer.rotateClockwise()
                : ApryseSDK.documentViewer.rotateCounterClockwise();
        };
        super({
            Enabled: true,
            Key: key,
            Path,
            Callback: GlobalVariables.registeredCommands[key],
        });
    }
}
